import React from "react";
import { useNavigate } from "react-router-dom";
import "./SubmissionFail.css";

function SubmissionFail() {
  const navigate = useNavigate();

  const handleBackToMain = () => {
    navigate("/");
  };

  const handleTryAgain = () => {
    navigate("/book-consultation");
  };

  return (
    <div className="App">
      <title>Submission Error — EffiGen LLC</title>
      <meta name="robots" content="noindex, nofollow" />
      <button
        className="back-button"
        onClick={handleBackToMain}
        aria-label="Back to main page"
      >
        ← Back to Main
      </button>

      <div className="submission-fail-container">
        <div className="submission-fail-content">
          <div className="fail-icon">
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                fill="#8a4a3a"
                stroke="#8a4a3a"
                strokeWidth="2"
              />
              <path
                d="M15 9l-6 6M9 9l6 6"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h1>We're Sorry</h1>
          <h2>Something went wrong with your submission.</h2>

          <p className="fail-description">
            We encountered an issue while processing your consultation request
            and appointment booking. This could be due to a temporary technical
            difficulty or network issue.
          </p>

          <div className="next-steps">
            <h3>What you can do:</h3>
            <ul>
              <li>Try submitting your request again</li>
              <li>
                Make sure to submit a calendar booking appointment. You should
                see a success message.
              </li>
              <li>
                Contact us directly if the problem persists
                dennis.morozov@effigen.ai
              </li>
              <li>We're here to help and will get back to you promptly</li>
            </ul>
          </div>

          <div className="action-buttons">
            <button className="primary-button" onClick={handleTryAgain}>
              Try Again
            </button>
            <button className="secondary-button" onClick={handleBackToMain}>
              Return to Main Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubmissionFail;
